import {SET_USERNAME} from './../constants';
import {SET_CUSTOMER_DATA} from './../constants';
import {SET_ADMIN_USER_DATA} from './../constants';
import {SET_CONTRACTOR_DATA} from './../constants';

export const setAuthUsername = (value) => ({
	type: SET_USERNAME,
	payload: value,
  });

  export const setCustomerData = (value) => ({
	type: SET_CUSTOMER_DATA,
	payload: value,
  });

  export const setAdminUserData = (value) => ({
	type: SET_ADMIN_USER_DATA,
	payload: value,
  });

  export const setContractorData = (value) => ({
	type: SET_CONTRACTOR_DATA,
	payload: value,
  });

  